import { Record, List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';

const defaultValues = {
  typeId: null,
  typeName: '',
  typeItemId: null,
  typeItemTextKey: '',
  typeItemName: '',
  iconName: '',
  iconURL: '',
  imageName: '',
  imageURL: '',
  displayDate: '',
  designTemplateCount: null,
  designTemplates: DesignTemplates(),
};

const s3BucketURL = APP_CONFIG.s3BucketURL;

export default class TypeItemGallery extends Record(defaultValues, TypeItemGallery) {
  constructor(values) {
    super({
      ...values,
      designTemplates: values && values.designTemplates
                       ?DesignTemplates(values.designTemplates)
                       :defaultValues.designTemplates,
    });
  }

  static getTypeItemGalleryByType(typeItemGalleries, type) {
    return typeItemGalleries.filter((typeItemGallery) => {
      return typeItemGallery.get('typeId') === type;
    });
  }

  static getTypeItemGalleryByFoodType(typeItemGalleries, type) {
	  let typeItemGalleriesByType = new List();
	  typeItemGalleries.forEach((typeItemGallery) => {
		  if (typeItemGallery.get('typeId') === type){
	           typeItemGallery = typeItemGallery.set('imageURL', `${ s3BucketURL }`+'system/cuisine-type-images/'+typeItemGallery.get('iconName')+'.png');
	 	       typeItemGallery = typeItemGallery.set('iconURL', `${ s3BucketURL }`+'system/cuisine-type-icons/'+typeItemGallery.get('iconName')+'.png');
	 	      typeItemGalleriesByType = typeItemGalleriesByType.push(typeItemGallery);
	 	    }
	    });
	    return typeItemGalleriesByType;
	  }

  static getTypeItemGalleryByBusinessType(typeItemGalleries, type) {
	  let typeItemGalleriesByType = new List();
	  typeItemGalleries.forEach((typeItemGallery) => {
		  if (typeItemGallery.get('typeId') === type){
	           typeItemGallery = typeItemGallery.set('imageURL', `${ s3BucketURL }`+'system/business-type-images/'+typeItemGallery.get('iconName')+'.png');
	 	       typeItemGallery = typeItemGallery.set('iconURL', `${ s3BucketURL }`+'system/business-type-icons/'+typeItemGallery.get('iconName')+'.png');
	 	      typeItemGalleriesByType = typeItemGalleriesByType.push(typeItemGallery);
	 	    }
	    });
	    return typeItemGalleriesByType;
	  }

  static getTypeItemGalleryByTypeItemId(typeItemGalleries, type) {
    return typeItemGalleries.filter((typeItemGallery) => {
      return typeItemGallery.get('typeItemId') === type;
    });
  }

  static getTypeItemDetailsByTypeItemId(typeItemGalleries, type) {
    return typeItemGalleries.find((item) => {
      return item.get('typeItemId') === type ? item : undefined;
    });
  }
  static setTypeItemGalleryByTypeItemId(typeItemGalleries, type, designTemplates) {
    return typeItemGalleries.map((typeItemGallery) => {
      return typeItemGallery.get('typeItemId') === type? typeItemGallery.set('designTemplates', designTemplates): typeItemGallery;
    });
  }

}

export const TypeItemGalleries = (data) => {
  let typeItemGalleries = new List();
  if (data) {
    data.forEach((value) => {
      typeItemGalleries = typeItemGalleries.push((value instanceof TypeItemGallery)? value: (new TypeItemGallery(value)));
    });
  }
  return typeItemGalleries;
};
